import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Page from 'components/_utility/page/Page.js';
import { GlobalContextProvider } from 'components/context/GlobalContext';
import { FormContextProvider } from 'components/context/FormContext';
import AuthContextProvider from 'components/context/AuthContext';
import { MsalProvider } from '@azure/msal-react';
import { msalInstance } from './msalInstance';

function App() {
  return (
    <MsalProvider instance={msalInstance}>
      <AuthContextProvider>
        <GlobalContextProvider>
          <FormContextProvider>
            <Router>
              <Routes>
                <Route path="/*" element={<Page />} />
              </Routes>
            </Router>
          </FormContextProvider>
        </GlobalContextProvider>
      </AuthContextProvider>
    </MsalProvider>
  );
}

export default App;
